export default { sha: '7b25ed820dc7fc6ee55882c7f5d4a51fe7986a27', buildNumber: 'undefined' }
